'use strict';

import http from '@/utils/http';
import { getFormData } from '@/utils';
import { validMobile, validEmail } from '@/utils/validation';

export default {
  getCaptcha(randomId) {
    return http
      .get(`/authority/anno/captcha?key=${randomId}`, {
        responseType: 'arraybuffer',
      })
      .then(
        data =>
          `data:image/png;base64,${btoa(
            String.fromCharCode(...new Uint8Array(data))
          )}`
      );
  },
  login(data) {
    return http.post('/authority/anno/login', getFormData(data));
  },
  getTenant(params) {
    return http.get('/authority/anno/getTenant', { params });
  },
  getCode(data) {
    if (validMobile(data)) {
      return http.post('/issmart-messages/sms/sendCode', { phone: data });
    }
    if (validEmail(data)) {
      return http.post('/issmart-messages/email/sendCode', { to: data });
    }
  },
  verifyCode({ account, code }) {
    if (validMobile(account)) {
      return http.post('/issmart-messages/sms/verify', {
        phone: account,
        code,
      });
    }
    if (validEmail(account)) {
      return http.post('/issmart-messages/email/verify', {
        to: account,
        code,
      });
    }
  },
  verifyAccount(data) {
    let temp = {};
    if (validMobile(data)) {
      temp.mobile = data;
    } else if (validEmail(data)) {
      temp.email = data;
    }
    return http.post('/authority/user/judgment/emailOrPhone', temp);
  },
};
